<template>
  <span>
    <exit v-if="obj.type === 'exit'" :info="obj" />
    <seat
      v-else-if="obj.type === 'seat'"
      :info="obj"
      :passenger="obj.passenger"
      :currentTravelerChoosing="obj.currentTravelerChoosing"
      :handleSeatSelection="
        () => {
          const { handleSeatSelection } = obj || {};
          if (handleSeatSelection) {
            handleSeatSelection(obj);
          }
        }
      "
    />
    <facility v-else-if="obj.type === 'facility'" :info="obj" />
    <div v-else :class="(obj.isExitRow ? 'small-map-block' : 'map-block') + ' empty'">
      <span class="block-info">{{ obj.row || '' }}</span>
    </div>
  </span>
</template>

<script>
import Exit from '@/components/blocks/seat-map/exit.vue';
import Seat from '@/components/blocks/seat-map/seat.vue';
import Facility from '@/components/blocks/seat-map/facility.vue';

export default {
  name: 'seat-map-block',
  components: {
    seat: Seat,
    exit: Exit,
    facility: Facility,
  },
  props: {
    obj: Object,
  },
};
</script>

<style lang="scss">
.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
</style>
